export const disableBackFunctionality = () => {
    window.history.pushState(null, '', window.location.href);
    window.onpopstate = () => window.history.go(1);
};
